import React, {Component} from "react";  
import config from 'react-global-configuration';
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {BeatLoader} from "react-spinners";
import {connect}  from  "react-redux";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(yesterday).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(yesterday).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(yesterday).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};

function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
function compareValues(val1, val2){
    if(Array.isArray(val1) && Array.isArray(val2)) {
        if(val1.length===val2.length){
            var is_unique = val1.every(i => val2.includes(i));
            if(is_unique===true){
                return true;
            } else {
                return true;
            }
        }
        else{
            return true;
        }

    } else {
        if(val1===val2){
            return true;
        } else {
            return true;
        }
    }
}
class EdcHealthReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            codeList:[],
            codeID:'',
            nameID:'',
            ciutidList: [],
            ciutidValue: null,
            ciutidIds: '',
            codeValue:null,
            nameList:[],
            loading1: true,
            loading:false,
            instList:[],
            instValue:[{value: "portal_mis_galaxy", label:"portal_mis_galaxy"}],
            instIds:["portal_mis_galaxy"],
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            txnLists:[{value:'Leg1 QR Transaction', label: 'Leg1'},{value:'Leg2 QR Transaction', label: 'Leg2'}],
            txnValue:'',
            txnIds:'',
            is_view_utid: false,
            isChange: false,
            listOpen: false,
            headerTitle: "Select [Utid]",
            merchantID:'',
            chainID:'',
            storeID:'',
            fetch_data:false
        }
        this.close = this.close.bind(this);
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidUpdate() {
        const { listOpen } = this.state;
        setTimeout(() => {
            if (listOpen) {
                window.addEventListener('click', this.close);
            } else {
                window.removeEventListener('click', this.close);
            }
        }, 0);
    }
    close() {
        this.setState({
            listOpen: false,
        });
    }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        this.setState({
            user_id:decoded._id
        });

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: decoded.object_code,
        });

        this.get_event_code();
        this.get_instance();
       
       
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {

            this.get_filtered_edc_health_report(decoded.object_type,arrayCode,'');

            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
            this.ci_utid('','','', false,'');
        }
        else if(decoded.object_type=='Merchant') {

            var merchantData = [{"value":decoded.object_code, "label":""}]
            //this.changeUtid(merchantData);
            setTimeout(function(){
                this.get_filtered_edc_health_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
            this.get_filtered_edc_health_report(decoded.object_type,arrayCode,'');
        }
        else if(decoded.object_type=='Chain') {
            setTimeout(function(){
                this.get_filtered_edc_health_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            var chainData = [{"value":decoded.object_code, "label":""}]
            //this.changeCode(chainData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
            })
            this.get_filtered_edc_health_report(decoded.object_type,arrayCode,'');
        }
        else if(decoded.object_type=='Store') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            setTimeout(function(){
                this.get_filtered_edc_health_report(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            //this.changeName(storeData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
            })
            this.get_filtered_edc_health_report(decoded.object_type,arrayCode,'');
        }
        else if(decoded.object_type=='Acquirer Bank') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            this.change_acq_banks(storeData);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: false,
            })
        }

        else {
            this.unauthorize_access();
        }
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'edc_health_report','sparcs')
    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(subMenuPermissions.includes("support_module")===false || reportPermissions.includes("edc_health")===false){
            this.unauthorize_access();
        }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }

    get_filtered_edc_health_report(object_type, object_code, event) {
        var that = this;
        disabledBody();
        var postData = {
            utid: this.state.ciutidIds,
            cids: this.state.codeID,
            nid: this.state.nameID,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            instance: this.state.instIds
        };
        if ($.fn.DataTable.isDataTable('#edcHealthTable')) {
            $('#edcHealthTable').DataTable().clear().destroy();
        }
        var edcHealthTable = $('#edcHealthTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                "responsive": true,
                //"scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/edc-health",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        enabledBody();
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody();
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        enabledBody()
                    },
                },

                columns: [
                    {"data":"Date" },
                    {"data":"Time" },
                    {"data":"Utid"},
                    // {"data":"Utid"},
                    {"data":"Event Code"},
                    {"data":"Event Name"},
                    {"data":"Additional Details"},
                    {"data":"Instance"},
                    {"data":"Prim ID"},
                    {"data":"APP Version"},
                    {"data":"stan Number"},


                ],
                "columnDefs": [
                    {  render: function (data) {
                        return data;
                    },

                        "targets": [5],
                        "className": "text-right"
                    },

                ],
            });
    }

    ci_utid(mid,cid,sid,is_search, search_value) {
        let utidList = [];
        let selected_val = '';
        if(is_search===true){
            selected_val = this.state.ciutidIds
        }
        this.setState({
            ciutidList: [],
            is_utid_loading: true
        })
        axios.post(config.get('API_URL') + '/reports/get-utid/', {

                mid: mid,
                cid: cid,
                sid: sid,
                is_search:is_search,
                search_value: search_value,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {

            if (Array.isArray(response.data) && response.data.length) {
                response.data.map((ci_utid, index) => {
                    utidList.push(ci_utid.utid)
                });
                if (Array.isArray(this.state.ciutidIds) && this.state.ciutidIds) {
                    utidList = utidList.filter( ( el ) => !this.state.ciutidIds.includes( el ) );
                    this.state.ciutidIds.map((ut,index) => {
                        utidList = [ut, ...utidList.filter(item => item !== ut)];
                    })

                }
                this.setState({
                    ciutidList: utidList,
                    is_utid_loading: false
                })

            } else {

                this.setState({
                    ciutidList: [],
                    is_utid_loading: false
                })
            }

        });
    }

    filterList(e){

        var value = e.target.value
        setTimeout(function() {
            this.ci_utid(this.state.merchantID, this.state.chainID, this.state.storeID, true, value);
        }.bind(this), 200);
    }
    toggleList() {
        this.setState({
            listOpen: !this.state.listOpen,
        });
    }

    changeUtid(utid,checked_item, e){
        let item_list = this.state.ciutidIds
        let checked_list = utid;
        //console.log(checked_list);
        if(checked_item===false) {
            const newData = [utid, ...this.state.ciutidList.filter(item => item !== utid)];
            this.setState({
                ciutidIds: [...this.state.ciutidIds,  utid],
                isChange: true,
                ciutidList: newData
            });

        } else{
            let index = item_list.indexOf(checked_list);
            if (index > -1) {
                item_list.splice(index, 1);
                if(item_list.length<1) {
                    item_list='';
                }
                this.setState({
                    ciutidIds: item_list,
                    isChange: true
                })
            }
        }


        if (e.target.type === 'checkbox') {
            e.stopPropagation();
        }
    }
    get_instance(){
        axios.get(config.get('API_URL')+'/reports/get-instance/',

                {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {

            let instList = [];
            instList.push({value: "", label: "All"})
            response.data.map((ev,index) => {
                instList.push({value: ev.instance_name, label: ev.instance_name})
            });
            this.setState({
                instList:instList,
            })
        });
    }
    changeInst(optionSelected) {
        let value='';
        let instArray = [];
        if(optionSelected.length<1){
            value = null;
            instArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                instArray.push(cids.value)
                // var index = this.state.codeList.findIndex(obj => obj.value==cids.value);
                // this.state.instList.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(instArray, this.state.active_instID);
        this.setState({
            instIds: instArray,
            instValue:optionSelected,
            isChange:is_enable

        });
        //this.get_filtered_edc_health_report(this.state.utidId, this.state.codeID, this.state.nameID, this.state.yestSend, this.state.todSend, instArray);


    }

    get_event_code(){
        axios.get(config.get('API_URL')+'/reports/get-event-details/',

            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let codeList = [];
            let nameList = [];
            response.data.map((ev,index) => {
                codeList.push({value: ev.event_code, label: ev.event_code})
                nameList.push({value: ev.event_name, label: ev.event_name})
            });
            this.setState({
                codeList:codeList,
                nameList:nameList
            })
        });
    }
    changeCode(optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                var index = this.state.codeList.findIndex(obj => obj.value==cids.value);
                this.state.codeList.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(cidArray, this.state.active_codeID);
        this.setState({
            codeID: cidArray,
            codeValue:optionSelected,
            isChange: is_enable

        });
        //this.get_filtered_edc_health_report(this.state.utidId, cidArray, this.state.nameID, this.state.yestSend, this.state.todSend, this.state.instIds);


    }

    
    changeName(optionSelected) {
        let value='';
        let sidArray = [];
        if(optionSelected.length<1){
            value = null;
            sidArray = '';
        }
        else{
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
                var index = this.state.nameList.findIndex(obj => obj.value==sids.value);
                this.state.nameList.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(sidArray, this.state.active_nameID);
        this.setState({
            nameID: sidArray,
            nameValue:optionSelected,
            isChange: is_enable
        });
        //this.get_filtered_edc_health_report(this.state.utidId, this.state.codeID, sidArray, this.state.yestSend, this.state.todSend, this.state.instIds);
    }


    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            var is_date_change = false;
            if(this.state.active_yestSend==this.state.yestSend && this.state.active_todSend==this.state.todSend){
                is_date_change = false;
            } else {
                is_date_change = true;
            }
            this.setState({
                isChange: is_date_change
            })
            //this.get_filtered_edc_health_report(this.state.utidId, this.state.codeID, this.state.nameID, this.state.yestSend, this.state.todSend, this.state.instIds)
        }
    }
EdcHealthReportDownloadCheck(){

    let is_inst = false;
    if(this.state.instIds.length===1 && this.state.instIds[0]==='portal_mis_galaxy')
    {
       is_inst = true;
    }
    if(this.state.ciutidIds==='' && this.state.codeID==='' && this.state.nameID==='' && is_inst ===true){
      confirmAlert({
            //title: 'Warning',
            message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
            buttons: [{
                label: 'OK',
                onClick: () => {
                    this.EdcHealthReportDownload();
                }
            },
                {
                    label: 'Cancel',
                }
            ]
        });
        } else {
        this.EdcHealthReportDownload()
        }
    }
    EdcHealthReportDownload (e){
        var that = this;
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);
        var days_beet = a.diff(b, 'days');
        if (days_beet > 30) {
            alert("Date range too large. Please select a date range of 30 days at a time");
            return false;
        }
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false
        });
        var postData = {
            utid: this.state.ciutidIds,
            cids: this.state.codeID,
            nid: this.state.nameID,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            instance: this.state.instIds,
            download: true

        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/edc-health-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
//             xhrFields: {
//                 responseType: 'blob'
//             },
            success: function (response, status, xhr) {
                this.copyEDCFile(response.data);
                this.setState({
                    fetch_data:true
                })
            }.bind(this),
            error: function(data) {
                that.closeModal();
                alert("Failed to download data. Please try again");
            }
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    copyEDCFile(remotePath){
        var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+'EDC_Health_report.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    reset_all(e){
        this.setState({
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            utidId:'',
            codeID:'',
            nameID:'',
            utidValue:[],
            codeValue:[],
            nameValue:[],
            instIds:["portal_mis_galaxy"],
            instValue:[{value: "portal_mis_galaxy", label:"portal_mis_galaxy"}],

        })

        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);
    }
    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };
        const utid_lists = this.state.ciutidList.map((utid_object, index) => {
            var chk_input = <input type='checkbox' checked={false}/>
            var activeCls = 'dd-list-item';
            var checked_item = false;
            if(this.state.ciutidIds.includes(utid_object) === true){
                chk_input = <input type='checkbox' checked={true}/>
                activeCls = "dd-list-item dd-list-active";
                checked_item = true;
            }
            return (
                <li key={index} className={activeCls} onClick={this.changeUtid.bind(this, utid_object,checked_item)}>
                    {chk_input}
                    &nbsp;&nbsp;{utid_object}
                </li>
            )
        })
        return(
          
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">EDC Health Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="">
                                        <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                            <div><label> Date Filter: </label></div>
                                            <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}
                                                             onEvent={this.handleEvent.bind(this)}  maxDate = {this.state.dateLimit}>
                                                <i className="fa fa-calendar" aria-hidden="true"></i>
                                                <input type="text" name="dateRange"
                                                       className="form-control dateRangeInput"
                                                       value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>
                                            </DateRangePicker>
                                        </div>

                                        <div className="col-md-2 filter-bottom5 padd-5" >
                                            <label> Utid: </label>
                                            <div className="dd-wrapper">
                                                <div className="dd-header" onClick={() => this.toggleList()}>
                                                    {this.state.ciutidIds==''?
                                                        <div className="dd-header-title">{this.state.headerTitle}</div>:
                                                        <div className="dd-header-title">{this.state.ciutidIds.length} Selected</div>
                                                    }

                                                    <i className="fa fa-angle-down"></i>
                                                </div>
                                                {this.state.listOpen ===true?
                                                    <div
                                                        role="list"
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <input
                                                            className="dd-list-search-bar"
                                                            placeholder="Search"
                                                            onChange={(e) => this.filterList(e)}
                                                        />
                                                        <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                                                        {/*<div className="dd-scroll-list">*/}
                                                        <ul className="dd-list">
                                                            {this.state.is_utid_loading===true?
                                                                <li>
                                                                    <BeatLoader
                                                                        css={override}
                                                                        sizeUnit={"px"}
                                                                        size={5}
                                                                        color={'#666666'}
                                                                        loading={this.state.is_utid_loading}
                                                                    />
                                                                </li>: null}
                                                            {utid_lists}

                                                        </ul> </div>: null }
                                                {/*</div>*/}
                                            </div>
                                            <div className="clearfix"></div>
                                        </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Event Code </label>
                                                <ReactMultiSelectCheckboxes name="chain"
                                                    isMulti
                                                    components={{ MenuList }}
                                                    value={this.state.codeValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeCode.bind(this)}
                                                    options={this.state.codeList}
                                                    placeholderButtonLabel="Select [Event Code]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Event Name </label>
                                                <ReactMultiSelectCheckboxes name="store"
                                                    isMulti
                                                    components={{ MenuList }}
                                                    value={this.state.nameValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeName.bind(this)}
                                                    options={this.state.nameList}
                                                    placeholderButtonLabel="Select [Event Name]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label> Instance </label>
                                            <ReactMultiSelectCheckboxes name="instance"
                                                                        isMulti
                                                                        value={this.state.instValue}
                                                                        styles={customStyles} className="report-listbox"
                                                                        isClearable={false}
                                                                        onChange={this.changeInst.bind(this)}
                                                                        options={this.state.instList}
                                                                        placeholderButtonLabel="Select [Instance]"
                                            />
                                            <div className="clearfix"></div>
                                        </div>




                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_edc_health_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            &nbsp;&nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>
                                    <div className="row">

                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.EdcHealthReportDownloadCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="edcHealthTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>Time</th>
                                                    <th>Utid</th>
                                                    {/*<th>Utid</th>*/}
                                                    <th>Event Code</th>
                                                    <th>Event Name</th>
                                                    <th>Additional Details</th>
                                                    <th>Instance</th>
                                                    <th>Prim ID</th>
                                                    <th>APP version</th>
                                                    <th>stan Number</th>


                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        {this.state.fetch_data===false?
                                                        <p>Fetching Data & Generating CSV...</p>:<p>Fetching File. Please wait...</p>}
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(EdcHealthReport)